import React, { useState, useEffect, useRef, useCallback } from 'react';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import {
  Grid,
  Button,
  Box,
  Chip, Divider,
} from "@material-ui/core";
import ProviderService from "../../../../Services/ProviderService";
import AuthenticationService from "../../../../Services/AuthenticationService";
import { isNotEmpty } from "../../../../utils/Validator";
import LoadingMsgBar from "../../../LoadingMsgBar";
import GlobalMessage from "../../../GlobalMessage";
import "./Physician.css";
import PhysicianGeneralView from './PhysicianGeneralView';
import PhysicianLicenseTbl from "./PhysicianLicenseTbl";
import PhysicianLocationTbl from "./PhysicianLocationTbl";
import PhysicianSpecialtyTbl from "./PhysicianSpecialtyTbl";
import PhysicianGeneralEdit from './PhysicianGeneralEdit';
import PhysicianSpecialtyEdit from './PhysicianSpecialtyEdit';
import PhysicianLocationEdit from './PhysicianLocationEdit';
import PhysicianLicenseEdit from './PhysicianLicenseEdit';
import PhysicianOthersEdit from './PhysicianProviderStatusEdit';
import GeneralInfoValidation from './GeneralInfoValidation';
import { isEmpty } from "../../../../utils/Validator";

const Physician = (props) => {
  // State for physician data
  const [physician, setPhysician] = useState(null);
  const [locations, setLocations] = useState([]);
  const [licenses, setLicenses] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [otherOptions, setOtherOptions] = useState({
    isRetired: false,
    isDeceased: false,
    leftGroup: false,
    notAcceptingWCPatients: false
  });

  const [userPermissions, setUserPermissions] = useState({
    canEditDemographics: false
  });
  const [isMirror, setIsMirror] = useState(false);
  // State for filtered data display
  const [filterLocations, setfilterLocations] = useState([]);
  const [filterLicenses, setfilterLicenses] = useState([]);
  const [filterSpecialties, setfilterSpecialties] = useState([]);

  // UI state
  const [errormsg, setErrormsg] = useState('');
  const [loadMsg, setLoadMsg] = useState('Loading Physician...');
  const [successMsg, setSuccessMsg] = useState('');
  //const [highlightMsg, setHighlightMsg] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);

  const [originalData, setOriginalData] = useState({
    physician: null,
    locations: [],
    licenses: [],
    specialties: [],
    otherOptions: {
      isRetired: false,
      isDeceased: false,
      notAcceptingWCPatients: false,
      otherNotes: ''
    }
  });

  // Section refs for form access

  const generalSectionRef = useRef(null);
  const specialtySectionRef = useRef(null);
  const locationSectionRef = useRef(null);
  const othersSectionRef = useRef(null);
  const licenseSectionRef = useRef(null);

  // Edit state tracking
  const [sectionObjects, setSectionObjects] = useState({
    general: { pristine: null, modified: null },
    specialties: { pristine: null, modified: null },
    licenses: { pristine: null, modified: null },
    locations: { pristine: null, modified: null },
    others: { pristine: null, modified: null }
  });

  const [unsavedSections, setUnsavedSections] = useState({
    general: false,
    specialties: false,
    licenses: false,
    locations: false,
    others: false
  });

  const [validatedSections, setValidatedSections] = useState({
    general: false,
    specialties: true,
    licenses: true,
    locations: true,
    others: true
  });

  const HighlightMessage = ({ message }) => {
    if (!message) return null;

    return (
      <p className="globalSuccessMessage" style={{
        backgroundColor: '#ffeb3b40',
        color: '#000000',           // Black text
        border: '1px solid #ffeb3b',
        fontWeight: '500'
      }}>
        {message}
      </p>
    );
  };




  const checkUserPermissions = useCallback(() => {
    let currentUser = AuthenticationService.getMirrorUser();
    if (isEmpty(currentUser)) {
      currentUser = AuthenticationService.getLoggedInUserName();
      setIsMirror(false);
    } else {
      setIsMirror(true);
    }

    // this.setState({ username: currentUser });
    //const currentUser = AuthenticationService.getLoggedInUserName();
    if (currentUser) {
      AuthenticationService.getUsrDtls(currentUser)
        .then(response => {
          if (response && response.data) {

            const hasTypePermission = response.data.typeCd === 'PRAD' || response.data.typeCd === 'PRUS';
            const hasFunctionPermission = Array.isArray(response.data.privilegedFunctions) &&
              response.data.privilegedFunctions.includes('DMGMNT');

            setUserPermissions({
              canEditDemographics: hasTypePermission && hasFunctionPermission
            });
          }
        })
        .catch(error => {
          console.error("Error fetching user details:", error);
        });
    }
  }, []);

  useEffect(() => {
    checkUserPermissions();
  }, [checkUserPermissions]);

  const getProviderPhysicianLocations = useCallback(() => {
    ProviderService.getProviderPhysicianLocations(props.selectedPrvId)
      .then((response) => {
        setLoadMsg('');
        if (isNotEmpty(response.data)) {
          const filteredByTin = response.data.filter(location =>
            location.ptcTaxId === props.selectedTin
          );
          setLocations(filteredByTin);
          setfilterLocations(filteredByTin);
        }
      }).catch((error) => {
        console.log('Error GETTING THE PROVIDER Physician' + error);
        setErrormsg(`Error GETTING THE PROVIDER Physician location ${error}`);
      });
  }, [props.selectedPrvId]);

  const getProviderPhysicianLicenses = useCallback(() => {
    ProviderService.getProviderLicenses(props.selectedPrvId)
      .then((response) => {
        setLoadMsg('');
        if (isNotEmpty(response.data)) {
          setLicenses(response.data);
          setfilterLicenses(response.data);
        }
      }).catch((error) => {
        console.log('Error GETTING THE PROVIDER Physician licenses' + error);
        setErrormsg('Error loading Physician licenses data.');
      });
  }, [props.selectedPrvId]);

  const getProviderPhysicianSpecialties = useCallback(() => {
    ProviderService.getProviderPhysicianSpecialties(props.selectedPrvId)
      .then((response) => {
        setLoadMsg('');
        if (isNotEmpty(response.data)) {
          setSpecialties(response.data);
          setfilterSpecialties(response.data);
        }
      }).catch((error) => {
        console.log('Error GETTING THE PROVIDER Physician Specialties' + error);
        setErrormsg('Error loading physician specialties');
        setLoadMsg('');
      });
  }, [props.selectedPrvId]);

  const getProviderPhysician = useCallback(() => {
    ProviderService.getProviderPhysician(props.selectedPrvId)
      .then((response) => {
        if (isNotEmpty(response.data)) {
          setPhysician(response.data);
          setLoadMsg('');
          // Call these independently
          getProviderPhysicianSpecialties();
          getProviderPhysicianLocations();
          getProviderPhysicianLicenses();
        } else {
          setErrormsg('Error loading Physician data.');
          setLoadMsg('');
        }
      }).catch((error) => {
        console.log('Error GETTING THE PROVIDER Physician' + error);
        setErrormsg('Error loading physician data');
        setLoadMsg('');
      });
  }, [props.selectedPrvId, getProviderPhysicianSpecialties, getProviderPhysicianLocations, getProviderPhysicianLicenses]);

  useEffect(() => {
    if (props.selectedPrvId) {
      getProviderPhysician();
    }
  }, [props.selectedPrvId, getProviderPhysician]);

  // Function to prepare license data for the edit form
  const prepareLicenseForEdit = (license) => {
    // Helper function to format dates to yyyy-MM-dd
    const formatDateToYYYYMMDD = (dateString) => {
      if (!dateString) return "";

      try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return ""; // Invalid date

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
      } catch (error) {
        console.error("Error formatting date:", error);
        return "";
      }
    };

    return {
      ...license,
      plicIssueDate: formatDateToYYYYMMDD(license.plicIssueDate),
      plicExpirationDate: formatDateToYYYYMMDD(license.plicExpirationDate)
    };
  };
  // Edit mode handlers
  const handleEditClick = () => {
    // Store original data as backup before entering edit mode
    setOriginalData({
      physician: { ...physician },
      locations: [...locations],
      licenses: [...licenses],
      specialties: [...specialties],
      otherOptions: { ...otherOptions }
    });
    setSuccessMsg('');
    //setHighlightMsg('');
    setIsEditing(true);
  };

  const handleCancelEdit = () => {
    // Restore data from backup
    getProviderPhysicianLocations();
    getProviderPhysicianSpecialties();
    getProviderPhysicianLicenses();

    // Reset UI state
    setIsEditing(false);
    setHasChanges(false);
    setErrormsg('');

    // Reset all section states
    setUnsavedSections({
      general: false,
      specialties: true,
      licenses: false,
      locations: false,
      others: false
    });

    setValidatedSections({
      general: false,
      specialties: true,
      licenses: true,
      locations: true,
      others: true
    });

    setSectionObjects({
      general: { pristine: null, modified: null },
      specialties: { pristine: null, modified: null },
      licenses: { pristine: null, modified: null },
      locations: { pristine: null, modified: null },
      others: { pristine: null, modified: null }
    });
  };
  // Section change handlers - consolidated
  const handleSectionSaveLocal = (sectionName, objects) => {
    //console.log(`${sectionName.toUpperCase()} SECTION - Save locally:`, objects);

    // Update the section objects state
    setSectionObjects(prev => ({
      ...prev,
      [sectionName]: {
        pristine: objects.pristineObject,
        modified: objects.modifiedObject
      }
    }));

    // Mark this section as saved and validated
    setUnsavedSections(prev => ({
      ...prev,
      [sectionName]: false
    }));

    setValidatedSections(prev => ({
      ...prev,
      [sectionName]: objects.isValid || false
    }));

    // Always set hasChanges to true if we have modified objects
    if (objects.modifiedObject) {
      setHasChanges(true);
    }
  };

  const handleSectionDiscardChanges = (sectionName, objects) => {
    //console.log(`${sectionName.toUpperCase()} SECTION - Discard changes:`, objects);

    // Update the section objects state
    setSectionObjects(prev => ({
      ...prev,
      [sectionName]: {
        pristine: objects.pristineObject,
        modified: null
      }
    }));

    // Mark section as not having unsaved changes
    setUnsavedSections(prev => ({
      ...prev,
      [sectionName]: false
    }));

    // Reset validation status for this section
    setValidatedSections(prev => ({
      ...prev,
      [sectionName]: sectionName !== 'general'
    }));

    // Check if there are any remaining changes in other sections
    const remainingChanges = Object.keys(sectionObjects)
      .filter(key => key !== sectionName)
      .some(key => sectionObjects[key].modified !== null);

    // Update hasChanges flag
    setHasChanges(remainingChanges);
  };

  const handleSectionHasChanges = (sectionName, hasUnsavedChanges) => {
    //console.log(`${sectionName.toUpperCase()} SECTION - Has unsaved changes:`, hasUnsavedChanges);

    // Update unsaved sections state
    setUnsavedSections(prev => ({
      ...prev,
      [sectionName]: hasUnsavedChanges
    }));

    // If a section has new changes, it needs validation again (for general section)
    if (hasUnsavedChanges && sectionName === 'general') {
      setValidatedSections(prev => ({
        ...prev,
        [sectionName]: false
      }));
    }
  };

  // Specific section handlers
  const handleValidationFunction = (validateFn) => {
    generalSectionRef.current = {
      ...generalSectionRef.current,
      validateForm: validateFn
    };
  };

  const handleSpecialtySectionChanges = (changes) => {
    //console.log("Specialty changes detected:", changes);

    // Check if we have any changes
    const hasSpecialtyChanges = changes && (
      (changes.newSpecialties && changes.newSpecialties.length > 0) ||
      (changes.modifiedSpecialties && changes.modifiedSpecialties.length > 0) ||
      (changes.deletedSpecialties && changes.deletedSpecialties.length > 0)
    );

    // Update unsaved sections state
    handleSectionHasChanges('specialties', hasSpecialtyChanges);

    if (hasSpecialtyChanges) {
      // Store changes in section objects
      setSectionObjects(prev => ({
        ...prev,
        specialties: {
          pristine: prev.specialties.pristine,
          modified: changes
        }
      }));
    }
  };

  const handleLicenseSectionChanges = (action, licenseData, originalData = null) => {
    //console.log(`License ${action} detected:`, licenseData);

    if (action === 'batch') {
      // Handle batch changes
      setSectionObjects(prevState => ({
        ...prevState,
        licenses: {
          pristine: prevState.licenses.pristine,
          modified: licenseData // licenseData is an array of change records in this case
        }
      }));

      // Mark licenses section as having changes
      handleSectionHasChanges('licenses', true);
    } else {
      // Handle individual changes (add, edit, delete)
      setSectionObjects(prevState => {
        const currentLicenseChanges = prevState.licenses.modified || [];

        // Create a change record
        const licenseId = licenseData?.prvId || (originalData?.prvId || 'unknown');
        const changeRecord = {
          action: action,
          licenseId: licenseId,
          newData: action !== 'delete' ? licenseData : null,
          oldData: action === 'edit' || action === 'delete' ? originalData : null,
          timestamp: new Date().getTime()
        };

        // Remove any previous actions on the same license
        const filteredChanges = Array.isArray(currentLicenseChanges)
          ? currentLicenseChanges.filter(change => change.licenseId !== licenseId)
          : [];

        return {
          ...prevState,
          licenses: {
            pristine: prevState.licenses.pristine,
            modified: [...filteredChanges, changeRecord]
          }
        };
      });

      // Mark licenses section as having changes
      handleSectionHasChanges('licenses', true);
    }
  };

  const handleOthersSectionChanges = (changes) => {
    //console.log("Others section changes detected:", changes);

    // Update section objects with other options changes
    setSectionObjects(prev => ({
      ...prev,
      others: {
        pristine: otherOptions,
        modified: changes
      }
    }));

    // Mark others section as having changes
    handleSectionHasChanges('others', true);
  };

  const handleLocationFilter = (filteredLocations) => {
    //console.log('Setting filtered locations:', filteredLocations);
    setfilterLocations(filteredLocations);
  };

  // Data update handlers
  const updateLicenses = (updatedLicenses) => {
    setLicenses(updatedLicenses);
    setfilterLicenses(updatedLicenses);
  };

  const updateLocations = (updatedLocations) => {
    setLocations(updatedLocations);
    setfilterLocations(updatedLocations);
  };


  const formatLocationObject = (location) => {
    // Extract focus information from the details array
    const focus = location.details && location.details.length > 0
      ? location.details.map(detail => detail.focusName || detail.focusShortDesc)
      : [];

    // Extract address components
    const addressComponents = location.addressComponents || {
      address1: '',
      address2: '',
      city: '',
      state: '',
      county: '',
      zip: '',
      zipExt: ''
    };

    // Helper function to format Y/N/empty to Yes/No/Not Set
    const formatAcceptingWcPatients = (flag) => {
      if (flag === 'Y') return 'YES';
      if (flag === 'N') return 'NO';
      if (!flag || flag.trim() === '') return 'Not Set';
      return flag; // Return as-is if it's already formatted (YES/NO)
    };

    return {
      name: location.phoOfficeName || "",
      practiceTIN: location.ptcTaxId || "",
      addressLine1: addressComponents.address1 || "",
      addressLine2: addressComponents.address2 || "",
      city: addressComponents.city || "",
      state: addressComponents.state || "",
      zipCode: addressComponents.zip || "",
      zipPlusFour: addressComponents.zipExt || "",
      county: addressComponents.county || "",
      phone: location.ofcDirectoryPhoneNbr || "",
      fax: location.ofcFaxNbr || "",
      email: location.ofcEmailAddress || "",
      acceptingNewWcPatients: formatAcceptingWcPatients(location.poflAcceptWcPatientsFlag),
      //acceptingNewWcPatientsDate: location.poflAcceptWcPatientsDate || null,
      acceptingNewWcPatientsDate: location.poflAcceptWcPatientsDate
        ? new Date(location.poflAcceptWcPatientsDate).toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        })
        : null,
      focuses: focus || location.details
    };
  };
  /**
   * Formats a license object for the API request
   * @param {Object} license - License data
   * @returns {Object} - Formatted license object
   */



  const formatLicenseObject = (license) => {
    // Helper function to format dates without timezone issues, similar to parseDateString in PhysicianLicenseEdit
    const formatDateToYYYYMMDD = (dateString) => {
      if (!dateString) return null;

      // Handle different date formats
      let parts;

      // If it's already in YYYY-MM-DD format
      if (dateString.includes('-')) {
        return dateString; // Already in the correct format, don't process further
      }

      // If it's in MM/DD/YYYY format
      if (dateString.includes('/')) {
        parts = dateString.split('/');
        if (parts.length === 3) {
          // Convert MM/DD/YYYY to YYYY-MM-DD
          const month = parts[0].padStart(2, '0');
          const day = parts[1].padStart(2, '0');
          const year = parts[2];
          return `${year}-${month}-${day}`;
        }
      }

      // If we can't parse it in a known format, try using Date but avoid timezone issues
      try {
        // Create date object and extract components directly without timezone conversion
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return null;

        // Use local date components and manually format to YYYY-MM-DD
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
      } catch (e) {
        console.error("Error parsing date:", e);
        return null;
      }
    };

    return {
      licenseType: license.ltrLicenseType || "",
      state: license.plicStateCode || "",
      licenseNumber: license.plicLicenseNbr || "",
      issueDate: formatDateToYYYYMMDD(license.plicIssueDate),
      expirationDate: formatDateToYYYYMMDD(license.plicExpirationDate),
      status: license.lsrStatus || "Active"
    };
  };

  // Save functionality
  const saveAllChanges = () => {
    // First validate all sections directly
    setLoadMsg('Validating changes...');
    setErrormsg('');

    // Get form data from all sections
    const generalData = generalSectionRef.current?.getFormData() || {};
    const specialtyData = specialtySectionRef.current?.getFormData?.() || {};
    const locationData = locationSectionRef.current?.getFormData?.() || {};
    const licenseData = licenseSectionRef.current?.getFormData?.() || {};
    const othersData = othersSectionRef.current?.getFormData?.() || {};

    console.log("SAVE ALL - General data:", generalData);
    console.log("SAVE ALL - Specialty data:", specialtyData);
    console.log("SAVE ALL - Location data:", locationData);
    console.log("SAVE ALL - License data:", licenseData);
    console.log("SAVE ALL - Others data:", othersData);

    // Validate general section
    let generalValid = true;
    if (generalData.modifiedObject) {
      const { fieldErrors, generalErrors } = GeneralInfoValidation.validateForm(generalData.modifiedObject);
      generalValid = Object.keys(fieldErrors).length === 0 && generalErrors.length === 0;

      if (!generalValid) {
        console.error("General section validation errors:", fieldErrors, generalErrors);
      }
    }



    // For other sections, use their internal validation if available
    let locationValid = true;
    if (locationSectionRef.current?.validateForm) {
      locationValid = locationSectionRef.current.validateForm() || true;
    }

    let licenseValid = true;
    if (licenseSectionRef.current?.validateForm) {
      licenseValid = licenseSectionRef.current.validateForm() || true;
    }

    let othersValid = true;
    if (othersSectionRef.current?.validateForm) {
      othersValid = othersSectionRef.current.validateForm() || true;
    }

    // Check if all sections are valid
    if (!generalValid || !locationValid || !licenseValid || !othersValid) {
      setErrormsg('Please fix validation errors before saving');
      setLoadMsg('');
      setTimeout(() => setErrormsg(''), 5000);
      return;
    }

    const hasOthersChanges = othersData && (
      othersData.isRetired !== otherOptions.isRetired ||
      othersData.isDeceased !== otherOptions.isDeceased ||
      othersData.leftGroup !== otherOptions.leftGroup
    );
    // Check if there are any changes to save
    const hasAnyChanges = generalData.modifiedObject ||
      specialtyData.modifiedObject ||
      locationData.modifiedObject ||
      licenseData.modifiedObject || hasOthersChanges;

    if (!hasAnyChanges) {
      setErrormsg(`No changes detected. Update the provider's demographic information or click 'CANCEL' at the bottom of this form to return.`);
      //setHighlightMsg(`No changes detected. Update the provider's demographic information or click 'CANCEL' at the bottom of this form to return.`);
      setLoadMsg('');
      window.scrollTo(0, 0);
      return;
    }

    setIsSaving(true);
    setLoadMsg('Saving changes...');

    // Create the provider identification info
    const providerIdentificationInfo = {
      providerId: props.selectedPrvId,
      providerName: `${physician?.phyFirstName || ""} ${physician?.phyLastName || ""}`.trim(),
      providerType: "Physician",
      primaryTIN: props.selectedTin,
      npi: physician?.prvNpi || ""
    };

    // Create individual objects for each change type
    let generalInfoChange = null;
    let specialtyChanges = null;
    let locationChanges = null;
    let licenseChanges = null;
    let providerStatusChange = null;

    // Populate general info changes if they exist
    if (generalData?.modifiedObject) {
      generalInfoChange = {
        action: "MODIFY",
        before: {
          firstName: generalData.pristineObject?.firstName || generalData.pristineObject?.phyFirstName || "",
          middleName: generalData.pristineObject?.middleName || generalData.pristineObject?.phyMiddleInitial || null,
          lastName: generalData.pristineObject?.lastName || generalData.pristineObject?.phyLastName || "",
          dateOfBirth: generalData.pristineObject?.dateOfBirth || generalData.pristineObject?.phyDOB || null,
          gender: generalData.pristineObject?.gender || generalData.pristineObject?.phyGender || null,
          languages: Array.isArray(generalData.pristineObject?.languages)
            ? generalData.pristineObject.languages
            : (generalData.pristineObject?.phyLanguages
              ? generalData.pristineObject.phyLanguages.split(', ').filter(Boolean)
              : []),
          degrees: Array.isArray(generalData.pristineObject?.degrees)
            ? generalData.pristineObject.degrees
            : (generalData.pristineObject?.phyDegrees
              ? generalData.pristineObject.phyDegrees.split(', ').filter(Boolean)
              : []),
          lob: generalData.pristineObject?.lob || ""
        },
        after: {
          firstName: generalData.modifiedObject?.firstName || generalData.modifiedObject?.phyFirstName || "",
          middleName: generalData.modifiedObject?.middleName || generalData.modifiedObject?.phyMiddleInitial || null,
          lastName: generalData.modifiedObject?.lastName || generalData.modifiedObject?.phyLastName || "",
          dateOfBirth: generalData.modifiedObject?.dateOfBirth || generalData.modifiedObject?.phyDOB || null,
          gender: generalData.modifiedObject?.gender || generalData.modifiedObject?.phyGender || null,
          languages: Array.isArray(generalData.modifiedObject?.languages)
            ? generalData.modifiedObject.languages
            : (generalData.modifiedObject?.phyLanguages
              ? generalData.modifiedObject.phyLanguages.split(', ').filter(Boolean)
              : []),
          degrees: Array.isArray(generalData.modifiedObject?.degrees)
            ? generalData.modifiedObject.degrees
            : (generalData.modifiedObject?.phyDegrees
              ? generalData.modifiedObject.phyDegrees.split(', ').filter(Boolean)
              : []),
          lob: generalData.modifiedObject?.lob || ""
        }
      };
    }

    // Populate specialty changes if they exist
    if (specialtyData?.modifiedObject) {
      specialtyChanges = [];
      const changesObj = specialtyData.modifiedObject.changes || specialtyData.modifiedObject;

      // Handle new specialties (ADD)
      if (changesObj.newSpecialties?.length > 0) {
        changesObj.newSpecialties.forEach(specialty => {
          specialtyChanges.push({
            action: "ADD",
            after: {
              providerType: specialty.providerTypeDesc,
              specialty: specialty.specDesc
            }
          });
        });
      }

      // Handle modified specialties (MODIFY)
      if (changesObj.modifiedSpecialties?.length > 0) {
        changesObj.modifiedSpecialties.forEach(change => {
          specialtyChanges.push({
            action: "MODIFY",
            before: {
              providerType: change.original.parrShortDesc,
              specialty: change.original.specDesc
            },
            after: {
              providerType: change.modified.parrShortDesc,
              specialty: change.modified.specDesc
            }
          });
        });
      }

      // Handle deleted specialties (REMOVE)
      if (changesObj.deletedSpecialties?.length > 0) {
        changesObj.deletedSpecialties.forEach(specialty => {
          specialtyChanges.push({
            action: "REMOVE",
            before: {
              providerType: specialty.providerTypeDesc,
              specialty: specialty.specDesc
            }
          });
        });
      }
      // If no changes were found, set specialtyChanges to null
      if (specialtyChanges.length === 0) {
        specialtyChanges = null;
      }
    }

    if (locationData?.modifiedObject) {
      locationChanges = [];

      if (locationData.modifiedObject.changes) {
        // Handle new locations (ADD) - WITH empty locationId inside object
        if (locationData.modifiedObject.changes.newLocations?.length > 0) {
          locationData.modifiedObject.changes.newLocations.forEach(location => {
            const formattedLocation = formatLocationObject(location);
            locationChanges.push({
              action: "ADD",
              after: {
                ...formattedLocation,
                locationId: ""  // Empty for new locations
              }
            });
          });
        }

        if (locationData.modifiedObject.changes.modifiedLocations?.length > 0) {
          locationData.modifiedObject.changes.modifiedLocations.forEach(change => {
            const formattedBefore = formatLocationObject(change.original);
            const formattedAfter = formatLocationObject(change.modified);

            locationChanges.push({
              action: "MODIFY",
              before: {
                ...formattedBefore,
                locationId: change.original.poflOfcId || ""
              },
              after: {
                ...formattedAfter,
                locationId: change.modified.poflOfcId || change.original.poflOfcId
              }
            });
          });
        }

        if (locationData.modifiedObject.changes.deletedLocations?.length > 0) {
          locationData.modifiedObject.changes.deletedLocations.forEach(location => {
            const formattedLocation = formatLocationObject(location);
            locationChanges.push({
              action: "REMOVE",
              before: {
                ...formattedLocation,
                locationId: location.poflOfcId
              }
            });
          });
        }
      }

      if (locationChanges.length === 0) {
        locationChanges = null;
      }
    }
    if (licenseData?.modifiedObject) {
      licenseChanges = [];
      // Handle new locations (ADD)
      if (licenseData.modifiedObject.changes.newLicenses?.length > 0) {
        licenseData.modifiedObject.changes.newLicenses.forEach(license => {
          licenseChanges.push({
            action: "ADD",
            after: formatLicenseObject(license)
          });
        });
      }

      // Handle modified locations (MODIFY)
      if (licenseData.modifiedObject.changes.modifiedLicenses?.length > 0) {
        licenseData.modifiedObject.changes.modifiedLicenses.forEach(change => {
          licenseChanges.push({
            action: "MODIFY",
            before: formatLicenseObject(change.original),
            after: formatLicenseObject(change.modified)
          });
        });
      }


      // Handle deleted locations (REMOVE)
      if (licenseData.modifiedObject.changes.deletedLicenses?.length > 0) {
        licenseData.modifiedObject.changes.deletedLicenses.forEach(license => {
          licenseChanges.push({
            action: "REMOVE",
            before: formatLicenseObject(license)
          });
        });
      }



      // If no changes were found, set locationChanges to null
      if (licenseChanges.length === 0) {
        licenseChanges = null;
      }
    }

    // Populate provider status changes if they exist
    if (othersData) {
      // Get the original data from the component state
      let status = null;

      if (othersData.isRetired) {
        status = "RETIRED";
      } else if (othersData.isDeceased) {
        status = "DECEASED";
      } else if (othersData.leftGroup) {
        status = "LEFT_GROUP";
      }

      // Only add the providerStatusUpdate if we have a status
      if (status) {
        providerStatusChange = {
          status: status
        };
      }

      // Log to verify the data
      console.log("Provider status update:", providerStatusChange);
    }
    // Create the request object with only populated properties
    const requestObject = {
      providerIdentificationInfo
    };

    // Add each change type only if it exists
    if (generalInfoChange) requestObject.generalInfoChange = generalInfoChange;
    if (specialtyChanges) requestObject.specialtyChanges = specialtyChanges;
    if (locationChanges) requestObject.locationChanges = locationChanges;
    if (licenseChanges) requestObject.licenseChanges = licenseChanges;
    //if (providerStatusChange) requestObject.providerStatusChange = providerStatusChange;
    if (providerStatusChange) requestObject.providerStatusUpdate = providerStatusChange;

    console.log("Provider info change request:", requestObject);

    // Call the provider info change service
    ProviderService.submitProviderInfoChange(requestObject)
      .then((response) => {
        // Handle the response from the provider info change service
        if (response.status === 200 || response.status === 201) {
          setLocations([]);
          setfilterLocations([]);
          setLicenses([]);
          setfilterLicenses([]);
          setSpecialties([]);
          setfilterSpecialties([]);

          getProviderPhysician();

          if (locationSectionRef.current && locationSectionRef.current.resetWorkingState) {
            locationSectionRef.current.resetWorkingState();
          }

          if (specialtySectionRef.current && specialtySectionRef.current.resetWorkingState) {
            specialtySectionRef.current.resetWorkingState();
          }

          if (licenseSectionRef.current && licenseSectionRef.current.resetWorkingState) {
            licenseSectionRef.current.resetWorkingState();
          }


          // Reset UI state
          setIsEditing(false);
          setHasChanges(false);
          setLoadMsg('');


          // Reset all section states
          setUnsavedSections({
            general: false,
            specialties: false,
            licenses: false,
            locations: false,
            others: false
          });

          setValidatedSections({
            general: false,
            specialties: true,
            licenses: true,
            locations: true,
            others: true
          });

          setSectionObjects({
            general: { pristine: null, modified: null },
            specialties: { pristine: null, modified: null },
            licenses: { pristine: null, modified: null },
            locations: { pristine: null, modified: null },
            others: { pristine: null, modified: null }
          });
          setSuccessMsg('Provider demographics changes submitted successfully. You will receive an email with your assigned case number.');
          //setTimeout(() => setSuccessMsg(''), 5000);
          window.scrollTo(0, 0);
        } else {
          throw new Error('Service returned an error status');
        }
      })
      .catch((error) => {
        console.error('Error saving changes:', error);
        setErrormsg('Error:  An error has occurred.  Please try again or contact Customer Service.');
        setLoadMsg('');
        window.scrollTo(0, 0);
      })
      .finally(() => {
        setIsSaving(false);
      });
  };
  return (
    <div className='App-content'>
      <LoadingMsgBar loadMsg={loadMsg} />
      <GlobalMessage message={errormsg} />
      <GlobalMessage type='success' message={successMsg} />

      {physician ? (
        <div>
          <Grid
            container
            justifyContent="space-between"
            style={{ width: "100%" }}
          >
            <Grid item style={{ width: "50%" }} justifyContent="left">
              <h1 className='App-page-label'>
                {`Physician - ${physician.phyLastName}, ${physician.phyFirstName} ${physician.phyMiddleInitial || ''}`}
              </h1>
            </Grid>
            <Grid item style={{ width: "50%" }} justifyContent="right">
              <Button
                variant="outlined"
                onClick={props.back}
                style={{ float: 'right' }}
                aria-label='PROVIDER DEMOGRAPHICS: BACK TO DEMOGRAPHICS SEARCH Button'
              >
                Back to Demographic Search
              </Button>
            </Grid>
          </Grid>

          {/* General Information Section */}
          <Accordion defaultExpanded>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Grid container justifyContent="space-between" alignItems="center" style={{ width: "100%" }}>
                <h5>General Information</h5>
                {isEditing && unsavedSections.general && (
                  <span style={{ color: '#f57c00', marginRight: '16px' }}>
                    Unsaved Changes
                  </span>
                )}
              </Grid>
            </AccordionSummary>
            <AccordionDetails>
              {isEditing ? (
                <PhysicianGeneralEdit
                  physician={physician}
                  selectedTin={props.selectedTin}
                  onValidationFunction={handleValidationFunction}
                  ref={generalSectionRef}
                  onSectionSaveLocal={objects => handleSectionSaveLocal("general", objects)}
                  onSectionDiscardChanges={objects => handleSectionDiscardChanges("general", objects)}
                  onSectionHasChanges={hasChanges => handleSectionHasChanges("general", hasChanges)}
                />
              ) : (
                <PhysicianGeneralView
                  physician={physician}
                  selectedTin={props.selectedTin}
                />
              )}
            </AccordionDetails>
          </Accordion>

          {/* Specialties Section */}
          <Accordion defaultExpanded={isEditing}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Grid container justifyContent="space-between" alignItems="center" style={{ width: "100%" }}>
                <h5>Specialties</h5>
                {isEditing && unsavedSections.specialties && (
                  <span style={{ color: '#f57c00', marginRight: '16px' }}>
                    Unsaved Changes
                  </span>
                )}
              </Grid>
            </AccordionSummary>

            {isEditing ? (
              <PhysicianSpecialtyEdit
                specialties={specialties}
                ref={specialtySectionRef}
                providerId={physician.prvId}
                onChange={handleSpecialtySectionChanges}
                onSectionSaveLocal={objects => handleSectionSaveLocal("specialties", objects)}
                onSectionDiscardChanges={objects => handleSectionDiscardChanges("specialties", objects)}
                onSectionHasChanges={hasChanges => handleSectionHasChanges("specialties", hasChanges)}
              />
            ) : (
              specialties.length > 0 ? (
                <PhysicianSpecialtyTbl
                  specialties={filterSpecialties}
                  setFilter={setfilterSpecialties}
                  filtered={specialties}
                />
              ) : (
                <span>No specialties found</span>
              )
            )}
          </Accordion>

          {/* Locations Section */}
          <Accordion defaultExpanded={isEditing}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel3a-content"
              id="panel3a-header"
            >
              <Grid container justifyContent="space-between" alignItems="center" style={{ width: "100%" }}>
                <h5>Locations</h5>
                {isEditing && unsavedSections.locations && (
                  <span style={{ color: '#f57c00', marginRight: '16px' }}>
                    Unsaved Changes
                  </span>
                )}
              </Grid>
            </AccordionSummary>

            {isEditing ? (
              <PhysicianLocationEdit style={{ width: '100%' }}
                locations={locations}
                setFilter={handleLocationFilter} selectedTin={props.selectedTin}
                filtered={filterLocations}
                updateLocations={updateLocations}
                onSectionSaveLocal={objects => handleSectionSaveLocal("locations", objects)}
                onSectionDiscardChanges={objects => handleSectionDiscardChanges("locations", objects)}
                onSectionHasChanges={hasChanges => handleSectionHasChanges("locations", hasChanges)}
                ref={locationSectionRef}
              />
            ) : (
              (locations.length > 0) ? (
                <PhysicianLocationTbl
                  style={{ width: '100%' }}
                  locations={filterLocations}
                  setFilter={setfilterLocations}
                  filtered={locations}
                />
              ) : (
                <span>No locations found</span>
              )
            )}

          </Accordion>

          {/* Licenses Section */}
          <Accordion defaultExpanded={isEditing}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel4a-content"
              id="panel4a-header"
            >
              <Grid container justifyContent="space-between" alignItems="center" style={{ width: "100%" }}>
                <h5>Licenses</h5>
                {isEditing && unsavedSections.licenses && (
                  <span style={{ color: '#f57c00', marginRight: '16px' }}>
                    Unsaved Changes
                  </span>
                )}
              </Grid>
            </AccordionSummary>

            {isEditing ? (
              <PhysicianLicenseEdit
                licenses={filterLicenses}
                filtered={licenses}
                setFilter={setfilterLicenses}
                updateLicenses={updateLicenses}
                onChange={handleLicenseSectionChanges}
                onSectionSaveLocal={objects => handleSectionSaveLocal("licenses", objects)}
                onSectionDiscardChanges={objects => handleSectionDiscardChanges("licenses", objects)}
                onSectionHasChanges={hasChanges => handleSectionHasChanges("licenses", hasChanges)}
                ref={licenseSectionRef}
              />
            ) : (
              (licenses.length > 0) ? (
                <PhysicianLicenseTbl
                  licenses={filterLicenses}
                  filtered={licenses}
                  setFilter={setfilterLicenses}
                />
              ) : (
                <span>No licenses found</span>
              )
            )}

          </Accordion>

          {/* Provider Status Section - Only visible in edit mode */}
          {isEditing && (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-others-content"
                id="panel-others-header"
              >
                <Grid container justifyContent="space-between" alignItems="center" style={{ width: "100%" }}>
                  <h5>Provider Status</h5>
                  {unsavedSections.others && (
                    <span style={{ color: '#f57c00', marginRight: '16px' }}>
                      Unsaved Changes
                    </span>
                  )}
                </Grid>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container>
                  <Grid item xs={12}>
                    <Divider style={{ marginBottom: '2px' }} />
                  </Grid>
                  <Grid item xs={12}>
                    <PhysicianOthersEdit
                      otherOptions={otherOptions}
                      onChange={handleOthersSectionChanges}
                      ref={othersSectionRef}
                      onSectionSaveLocal={objects => handleSectionSaveLocal("others", objects)}
                      onSectionDiscardChanges={objects => handleSectionDiscardChanges("others", objects)}
                      onSectionHasChanges={hasChanges => handleSectionHasChanges("others", hasChanges)}
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          )}

          {/* Action Buttons */}
          <Grid
            container
            justifyContent="space-between"
            style={{ width: "100%", marginTop: "20px" }}
          >
            <Grid item style={{ width: "50%" }} justifyContent="left">
              {isEditing ? (
                <Box display="flex" gap={2}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={handleCancelEdit}
                    startIcon={<CancelIcon />}
                    disabled={isSaving}
                    aria-label="Cancel editing"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={saveAllChanges}
                    startIcon={<SaveIcon />}
                    disabled={isSaving || isMirror}
                    aria-label="Save all changes"
                  >
                    SUBMIT All CHANGES
                  </Button>
                </Box>
              ) : (
                userPermissions.canEditDemographics && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleEditClick}
                    startIcon={<EditIcon />}
                    aria-label="Edit physician demographics"
                  >
                    Edit Demographics
                  </Button>
                )
              )}
            </Grid>
            <Grid item style={{ width: "50%" }} justifyContent="right">
              <Button
                variant="outlined"
                onClick={props.back}
                style={{ float: 'right' }}
                aria-label='PROVIDER DEMOGRAPHICS: BACK TO DEMOGRAPHICS SEARCH Button'
                disabled={isEditing && isSaving}
              >
                Back to Demographic Search
              </Button>
            </Grid>
          </Grid>
        </div>
      ) : (
        <div>Loading physician data...</div>
      )}
    </div>
  );
};

export default Physician;